module.exports = __webpack_public_path__ + "static/extraFallback@2x-7e1bf6028e461148db63ea67b3b142ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/extraFallback@2x.png
// module id = 2588
// module chunks = 168707334958949